import { render } from "./Indexx.vue?vue&type=template&id=bf1818de&scoped=true"
import script from "./Indexx.vue?vue&type=script&lang=js"
export * from "./Indexx.vue?vue&type=script&lang=js"

import "./Indexx.vue?vue&type=style&index=0&id=bf1818de&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf1818de"]])

export default __exports__